import React, { Component } from "react";

import _ from "lodash";
import { Link, withRouter } from "react-router-dom";

import {
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText,
  Row,
  Col
} from "reactstrap";

import { Form, Checkbox } from "semantic-ui-react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { TablePagination } from "react-pagination-table";
import isEmpty from "lodash/isEmpty";

import { postPrescriptions, presc_modal_view } from "../../actions/mqttAction";

class DraftComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      searchList: [],
      search: false,
      searchTerm: ""
    };
    this.handlePageChange = this.handlePageChange.bind(this);
    this.delete = this.delete.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    let draft_count = 0,
      reject_count = 0;
    this.props.drafted.map(presc => {
      if (presc.rxInfo.rxStatus === "Draft") {
        draft_count += 1;
      }
      if (presc.rxInfo.rxStatus === "Rejected") {
        reject_count += 1;
      }
    });
    if (reject_count > 0) {
      this.setState({
        searchList: this.props.drafted.filter(presc => presc.rxInfo.rxStatus === "Rejected"),
        draft_count: draft_count,
        reject_count: reject_count
      });
    } else {
      this.setState({
        searchList: this.props.drafted,
        draft_count: draft_count,
        reject_count: reject_count
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.drafted) {
      let draft_count = 0,
        reject_count = 0;
      nextProps.drafted.map(presc => {
        if (presc.rxInfo.rxStatus === "Draft") {
          draft_count += 1;
        }
        if (presc.rxInfo.rxStatus === "Rejected") {
          reject_count += 1;
        }
      });
      if (reject_count > 0) {
        this.setState({
          searchList: nextProps.drafted.filter(presc => presc.rxInfo.rxStatus === "Rejected"),
          draft_count: draft_count,
          reject_count: reject_count
        });
      } else {
        this.setState({
          searchList: nextProps.drafted,
          draft_count: draft_count,
          reject_count: reject_count
        });
      }
    }
  }

  handlePageChange(pageNumber) {
    console.log(`active page is ${pageNumber}`);
    this.setState({ activePage: pageNumber });
  }

  onSearch = e => {
    e.preventDefault();
    this.setState({ search: true });
    this.setState({ searchTerm: e.target.value.toLowerCase() }, () => {
      let filterDrafted;
      filterDrafted = _.filter(
        this.props.drafted,
        draft =>
          draft.patientInfo.firstName
            .toLowerCase()
            .includes(this.state.searchTerm) ||
          draft.patientInfo.lastName
            .toLowerCase()
            .includes(this.state.searchTerm) ||
          draft.rxInfo.prescriptionNumber
            .toLowerCase()
            .includes(this.state.searchTerm)
      );
      this.setState({ searchList: filterDrafted });
    });
  };

  delete = item => {
    let orgId;

    if (this.props.auth.user.orgId) orgId = this.props.auth.user.orgId;
    else orgId = 1;
    let branchName;
    localStorage.branch
      ? (branchName = localStorage.branch)
      : (branchName = "Chama");
    let draftedNew = this.props.drafted;
    let index = draftedNew.findIndex(
      x => x.rxInfo.prescriptionNumber === item.rxInfo.prescriptionNumber
    );
    draftedNew.splice(index, 1);
    let deleted = item.rxInfo;
    this.setState({
      drafted: draftedNew
    });
    item.rxInfo.rxStatus = "Deleted";
    item.prescriptionStatus = "Deleted"

    this.props.postPrescriptions(orgId, item, this.props.history);
  };

  openModalView(draftPrescription) {
    let isView = true;
    let prescription = draftPrescription;
    let patientId = draftPrescription.patientInfo.patientId;
    let prescriptionNumber = draftPrescription.rxInfo.prescriptionNumber;
    this.props.presc_modal_view(
      isView,
      prescription,
      patientId,
      prescriptionNumber
    );
  }

  handleChange = (e, { checked }) => {
    //console.log("===============Chaged Value==============="+e.target.id)

    if (e.target.id === "draft") {
    }
    if (e.target.id === "rejected") {
    }
  };


  render() {
    const headers = [
      "Edit",
      "Name",
      "Prescription",
      "Branch",
      "Tab",
      "ReceivedAt",
      "Delete"
    ];
    let draftedArray = [];
    this.state.searchList.sort(function (a, b) {
      return new Date(b.updateAt) - new Date(a.updateAt);
    });
    this.state.searchList.map(draft => {
      let date = "";
      let time = "";
      if (draft.updateAt) {
        date = String(draft.updateAt).split(" ")[0];
        time = String(draft.updateAt).split(" ")[1];
      }

      draftedArray.push({
        edit: (
          <Link to='#' onClick={() => this.openModalView(draft)}>
            {draft.rxInfo.rxStatus === "Draft" ? (
              <i
                className="fas fa-edit"
                onClick={() => this.openModalView(draft)}
              />
            ) : (
              <i
                className="text-danger fa-2x fas fa-thumbs-down"
                onClick={() => this.openModalView(draft)}
              />
            )}
          </Link>
        ),
        name: (
          <Link to='#' onClick={() => this.openModalView(draft)}>
            <span className="text-capitalize">
              <strong>
                {draft.patientInfo.firstName.toUpperCase()} {draft.patientInfo.lastName.toUpperCase()}
              </strong>
              <div className="text-info">{draft.patientInfo.dateOfBirth}</div>
            </span>
          </Link>
        ),
        prescription: (
          <Link to='#' onClick={() => this.openModalView(draft)}>
            <span>
              <strong>{draft.rxInfo.prescriptionNumber}</strong>
              <div className="text-info rx-name">{draft.rxInfo.rxName}</div>
            </span>
          </Link>
        ),
        branch: (
          <div>{isEmpty(draft.branchName) ? "N/A" : draft.branchName}</div>
        ),
        tab: <span>{draft.rxInfo.rxType}</span>,
        date: (
          <span>
            {date}
            <br></br>
            <span className="text-info">{time}</span>
          </span>
        ),

        delete: (
          <i
            class="far fa-trash-alt"
            onClick={() => {
              this.delete(draft);
            }}
            style={{ color: "rgb(215, 61, 50)", cursor: "pointer" }}
          ></i>
          // <Button
          //   color="info"
          //   size="md"
          //   className="mx-2"
          //   onClick={() => {
          //     this.delete(draft);
          //   }}
          // >
          //   Delete
          // </Button>
        )
      });
    });

    const drafted = (
      <TablePagination
        //headers={headers}
        data={draftedArray}
        columns="edit.name.prescription.branch.tab.date.delete"
        perPageItemCount={6}
        totalCount={this.props.drafted.length}
        arrayOption={[[]]}
        className={
          "text-center table table-borderless table-striped font-style"
        }
        paginationClassName={"react-paginate"}
      />
    );

    return (
      <div>

        <div className="py-2">
          <Row className=" pl-2">
            <Col>
              <InputGroup className="mb-3">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  onChange={this.onSearch.bind(this)}
                />
              </InputGroup>
            </Col>
            <Col style={{ color: "teal" }} style={{ marginLeft: "20%" }}>
              {/* <Form.Field

                    control={Checkbox}
                    id="draft"
                    label={<label><strong>Draft  :</strong> {this.state.draft_count}</label>}
                    
                    onChange={this.handleChange}
                  /> */}
              <label>
                <strong>Draft :</strong> {this.state.draft_count}
              </label>
            </Col>
            <Col style={{ color: "teal" }}>
              {/* <Form.Field
                    control={Checkbox}
                    id="rejected"
                    label={<label><strong>Rejected  :</strong> {this.state.reject_count} </label>}
                    onChange={this.handleChange}
                  /> */}
              <label>
                <strong>Rejected :</strong> {this.state.reject_count}{" "}
              </label>
            </Col>
          </Row>

          {drafted}
        </div>
      </div>
    );
  }
}

DraftComponent.propTypes = {
  postPrescriptions: PropTypes.func.isRequired,
  presc_modal_view: PropTypes.func.isRequired
};
const mapStateToProps = state => ({
  mqtt: state.mqtt,
  auth: state.auth
});
export default connect(mapStateToProps, {
  postPrescriptions,
  presc_modal_view
})(withRouter(DraftComponent));
